import React, { useState } from 'react';
import classNames from 'classnames';
import { Icon } from 'ui';
import Clamp from 'shiitake';
import { toList } from 'utils/string_utils';

const BootstrapTooltip = props => (
  <span
    className={props.className}
    data-container="body"
    data-toggle="tooltip"
    title={props.tooltip}
    data-placement={props.dataPlacement}
  >
    <Icon name={props.iconName} className={`c-p ${props.iconClasses}`} />
  </span>
);

const ContentPickerItem = ({
  id,
  title,
  iconName,
  onClick,
  count,
  countLabel,
  tags,
  layout,
  active,
  clamp,
  infoTooltip,
  invalidTooltip,
  showCount,
  invalid,
  nestedContent,
}) => {
  const [tagsVisible, setTagsVisible] = useState(false);

  const showTagsTooltip = tags.length >= 2;

  const handleClick = () => {
    if (onClick && !invalid) {
      onClick(id);
    }
  };

  const toggleTagsVisibility = () => {
    setTagsVisible(prev => !prev);
  };

  const handleTagsPillClick = e => {
    // eslint-disable-line
    e.stopPropagation();
  };

  const tagsLabel = () => {
    return tags.length === 1 ? tags[0].name : `${tags.length} Tags`;
  };

  const contentItemClassName = classNames('ContentItem', {
    'ContentItem--card': layout === 'card',
    'ContentItem--list': layout === 'list',
    'ContentItem--active': active,
    'ContentItem--clickable': !!onClick && !invalid && !nestedContent,
    'ContentItem--disabled': invalid,
    'ContentItem--nested': nestedContent,
  });

  const tagsPillClassName = classNames('ContentItem-tagsPill', {
    'Pill Pill--gray tt-u Pill--small': true,
    'ContentItem-tagsPill--withTooltip': showTagsTooltip,
  });

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <div
      onClick={() => {
        if (!nestedContent) handleClick();
      }}
      className={contentItemClassName}
    >
      <div className="ContentItem-info">
        {iconName && (
          <Icon name={iconName} className="ContentItem-icon midnight-100" />
        )}
        <Clamp
          className="ContentItem-title ws-pr"
          lines={clamp[layout].title}
          children={title}
        />
        {nestedContent && (
          <p className="ContentItem-nested">
            {t('journeys.builder.path_nested')}
          </p>
        )}
      </div>
      {showTagsTooltip && tagsVisible && (
        <div className="ContentItem-tagsPopover">
          <Clamp lines={clamp[layout].tags} tagName="span">
            {toList(
              tags.map(t => t.name),
              true,
            )}
          </Clamp>
        </div>
      )}
      <div className="ContentItem-meta">
        {(showCount || !!count) && (
          <div>
            <span className="ContentItem-count">
              {count} {countLabel}
            </span>
            {invalid && (
              <BootstrapTooltip
                className="ml-4"
                tooltip={invalidTooltip}
                dataPlacement="top"
                iconName="warning_sign"
                iconClasses="c-brand-red"
              />
            )}
            {infoTooltip && !invalid && (
              <BootstrapTooltip
                className="ml-4"
                tooltip={infoTooltip}
                dataPlacement="top"
                iconName="info"
                iconClasses="ContentItem--hoverColorStyles midnight-70"
              />
            )}
          </div>
        )}
        {!!tags.length && (
          <button
            type="button"
            className={tagsPillClassName}
            onMouseEnter={toggleTagsVisibility}
            onMouseLeave={toggleTagsVisibility}
            onClick={handleTagsPillClick}
            children={tagsLabel()}
          />
        )}
      </div>
    </div>
  );
};

ContentPickerItem.defaultProps = {
  tags: [],
  layout: 'card',
  clamp: {
    list: {
      tags: 2,
      title: 1,
    },
    card: {
      tags: 3,
      title: 2,
    },
  },
};

export default ContentPickerItem;
